export enum PersonalDataFormFields {
  Name = 'first_name',
  LastName = 'last_name',
  PanCardNumber = 'pan_card_number',
  EducationId = 'education_id',
  MaritalStatus = 'marital_status_id',
  Email = 'email',
  Children = 'children',
}

export enum EmplaymentDetailsFormFields {
  employmentType = 'employment_type',
}

export enum AdditionalInfoFormFields {
  contactName = 'contact_name',
  contactPhoneNumber = 'contact_phone_number',
  contactRelationship = 'contact_relationship',
}